import React, {useMemo} from "react"
import {makeStyles} from "@material-ui/core/styles"
import CircularProgress from "@material-ui/core/CircularProgress"

const useStyles = makeStyles(() => ({
  root: {
    display: `flex`,
    flexDirection: `row`,
    flexWrap: `wrap`,
    justifyContent: `center`,
    width: `100%`,
    height: `150px`,
  },
}))

export default function CircleBar() {
  const classes = useStyles()
  return useMemo(
    () => (
      <div className={classes.root}>
        <CircularProgress size={150} thickness={5} />
      </div>
    ),
    [classes],
  )
}
